import { render, staticRenderFns } from "./MobileHeaderBack.vue?vue&type=template&id=2c64b055&"
import script from "./MobileHeaderBack.vue?vue&type=script&lang=js&"
export * from "./MobileHeaderBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports